import { PayoutOrderPublicStatus, payoutOrderPublicStatuses } from '~/entities/payout';

export const statuses = payoutOrderPublicStatuses.filter((status) => {
    return (
        status.value === PayoutOrderPublicStatus.PUBLIC_STATUS_COMPLETED ||
        status.value === PayoutOrderPublicStatus.PUBLIC_STATUS_FAILED
    );
});
